import React, { useState, useEffect } from 'react';
import { lunchboxService } from '../../lib/services/lunchbox';
import LunchboxCalendar from './LunchboxCalendar';
import LunchboxHome from './LunchboxHome';
import './LunchboxModule.css';

const LunchboxModule = ({ currentUser, onBack, onTabChange }) => {
  const [currentView, setCurrentView] = useState('home'); // 'home' or 'calendar'
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState({});

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      setLoading(true);
      setError(null);

      const statistics = await lunchboxService.getLunchboxStats();
      setStats(statistics);
    } catch (err) {
      console.error('Error loading lunchbox data:', err);
      setError('載入飯盒系統資料時發生錯誤');
    } finally {
      setLoading(false);
    }
  };

  const handleViewChange = (view) => {
    setCurrentView(view);
  };

  if (loading) {
    return (
      <div className="lunchbox-module">
        <div className="lunchbox-header">
          <button className="back-btn" onClick={onBack}>
            ← 返回主頁
          </button>
          <h1>學校飯盒系統</h1>
        </div>
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>載入飯盒系統中...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="lunchbox-module">
        <div className="lunchbox-header">
          <button className="back-btn" onClick={onBack}>
            ← 返回主頁
          </button>
          <h1>學校飯盒系統</h1>
        </div>
        <div className="error-container">
          <p>❌ {error}</p>
          <button onClick={loadInitialData} className="retry-btn">
            重新載入
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="lunchbox-module">
      <div className="lunchbox-header">
        <button className="back-btn" onClick={onBack}>
          ← 返回主頁
        </button>
        <h1>學校飯盒系統</h1>
        <div className="lunchbox-nav">
          <button 
            className={`nav-btn ${currentView === 'home' ? 'active' : ''}`}
            onClick={() => handleViewChange('home')}
          >
            主頁
          </button>
          <button 
            className={`nav-btn ${currentView === 'calendar' ? 'active' : ''}`}
            onClick={() => handleViewChange('calendar')}
          >
            月曆表
          </button>
        </div>
      </div>

      <div className="lunchbox-content">
        {currentView === 'home' && (
          <LunchboxHome 
            stats={stats}
            onNavigateToCalendar={() => handleViewChange('calendar')}
          />
        )}
        
        {currentView === 'calendar' && (
          <LunchboxCalendar 
            stats={stats}
            onBack={() => handleViewChange('home')}
          />
        )}
      </div>
    </div>
  );
};

export default LunchboxModule;
